import React, {useContext } from "react";
import { WebContext} from "../../../Utility";
import Typography from "@material-ui/core/Typography";
import  Box  from "@material-ui/core/Box";
import useStyles from "./styles.js";
import LocalStorage from "../../../LocalStorage";
import { StyledMuiButton2 } from "../../Commons/styledTabs";
import LoginSignUpModal from "./loginSignUpModal";
import { NewButtonLogin } from "../Commons/AnimationButton.jsx";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AnimationButton from "../Commons/AnimationButton.jsx";
import { useTheme } from "@material-ui/core/styles";
const LoginButton = (props) => {
  const {
    showLoginModal: { status = false, err = "" },
    setShowLoginModal,
    isLoggedIn = false,
    deskTopView = false,
  } = useContext(WebContext);
  const classes = useStyles();
  const theme = useTheme();
  let user = LocalStorage.getUser();
  let { username = "" } = user || {};
  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const NotLoggedInView = () => {
    return (
      <>
      {
        // toor theme  primary button
         props?.primarycolor ? <Box onClick={() => {
            setShowLoginModal({ status: true });
          }}><AnimationButton name={'LOGIN'} primarycolor={props?.primarycolor} width={'140px'} height={'40px'}/></Box>
          // toor theme secondary color button
          :props?.loginButton
          ? <Box onClick={() => {
            setShowLoginModal({ status: true });
          }}><NewButtonLogin name={'LOGIN'}  width={'140px'} height={'40px'}/></Box>:
          // default button 
          <StyledMuiButton2
          variant="outlined"
          className={`${classes.loginButtonStyle} ${props.loginClass}`}
          onClick={() => {
            setShowLoginModal({ status: true });
          }}
        >
          Login
        </StyledMuiButton2>
      }
        
      </>
    );
  };
  const LoggedInView = () => {
    return (
      <>
        {deskTopView ? (
          <Box className={`${classes.loginButtonStyle} ${props.loginClass}`}>
            <div
              className={`${classes.navTextHover} ${classes.navBarTextContainer} ${classes.navLink}`}
            >
              <Typography variant="body1" className={`${classes.navBarText}`}>
                Hi {capitalizeFirstLetter(username)}
              </Typography>{" "}
              {props?.tab !== "paradise" && (
                <ExpandMoreIcon
                  style={{ color: theme?.agentTheme?.primary?.main }}
                />
              )}
            </div>
          </Box>
        ) : (
          <Box className={`${classes.loginButtonStyle} ${props.loginClass}`}>
            <div
              className={`${classes.navTextHover} ${classes.navBarTextContainer} ${classes.navLink}`}
            >
              <Typography
                variant="body1"
                noWrap={true}
                className={`${classes.navBarText}`}
                style={{color:props?.colornavbar15 ? theme?.agentTheme?.secondary?.main:theme?.agentTheme?.primary?.main}}
              >{`Hi, ${capitalizeFirstLetter(username)}`}</Typography>
            </div>
          </Box>
        )}
      </>
    );
  };

  return (
    <>
      {status && (
        <LoginSignUpModal
          onClose={() => setShowLoginModal({ status: false })}
          errMsg={err}
        />
      )}
      {isLoggedIn ? <LoggedInView /> : <NotLoggedInView />}
    </>
  );
};

export default LoginButton;
